import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const MODULE_VERSION_OUTPUTS_TABLE_STORAGE_KEY = "moduleVersionOutputsTableStorageKey";
export const MODULE_VERSION_OUTPUTS_TABLE_FILTERS_STORAGE_KEY =
  "moduleVersionOutputsTableFiltersStorageKey";

export enum MODULE_VERSION_OUTPUTS_COLUMN_ID {
  NAME = "NAME",
  DESCRIPTION = "DESCRIPTION",
}

const MAX_CELL_WIDTH = 2000;

export const MODULE_VERSION_OUTPUTS_TABLE_COLUMNS_CONFIG: Record<
  MODULE_VERSION_OUTPUTS_COLUMN_ID,
  TableColumnMeta
> = {
  [MODULE_VERSION_OUTPUTS_COLUMN_ID.NAME]: {
    id: MODULE_VERSION_OUTPUTS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 180,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    // Settings are hidden on this table, so there is no chrome to hide, pin, or move against.
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
  [MODULE_VERSION_OUTPUTS_COLUMN_ID.DESCRIPTION]: {
    id: MODULE_VERSION_OUTPUTS_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 200,
    defaultWidth: 500,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
};

/** DESCRIPTION is here only to satisfy the exhaustive Record; nothing reads it (allowsSorting: false). */
export const SORT_CONFIG: Record<MODULE_VERSION_OUTPUTS_COLUMN_ID, string> = {
  [MODULE_VERSION_OUTPUTS_COLUMN_ID.NAME]: "name",
  [MODULE_VERSION_OUTPUTS_COLUMN_ID.DESCRIPTION]: "description",
};

export const INITIAL_SORT_OPTION = SORT_CONFIG[MODULE_VERSION_OUTPUTS_COLUMN_ID.NAME];
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Asc;
